import axios from 'axios'
import store from '@/store'
import router from '@/router'

// Request interceptors
axios.interceptors.request.use(request => {
  const token = store.getters['auth/token']
  if (token) {
    request.headers.common['Authorization'] = 'Bearer ${token}'
  }

  return request
})


// Response interceptors
axios.interceptors.response.use(response => response, error => {
  const { status } = error.response

  if (status >= 500) {

  }

  if (status === 401 && store.getters['auth/check']) {
    store.commit('auth/LOGOUT')

    router.push({ name: 'auth.login' })
  }

  return Promise.reject(error)
})


// WEBPACK FOOTER //
// ./src/plugins/axios.js